<template>    
    <v-layout>
        <keep-alive>        
            <component 
                :is="mainform"
                :formdata="formdata"  
                v-on:submitcomplete="onSubmitComplete"
            ></component>
        </keep-alive>
        <formstopperdialog 
            :show="loading">            
        </formstopperdialog>
    </v-layout>
</template>
<script>
    import { mapGetters } from 'vuex';
    import mainform from "../components/forms/MainForm.vue";
    import formstopperdialog from "../components/forms/FormStopperDialog.vue";
    export default {   
    
    props: [
        
    ],
    components: {
        mainform:"mainform",
        formstopperdialog,  
    },
    data() {
        return {  
            mainform:mainform,
            loading:false,
            formstopperdialog: formstopperdialog,
                    
        }
    },
    computed: {
        ...mapGetters({
            formdata: 'companies/formdata',
            companies: 'conpanies/companies'
        }),
    },
    methods: {
        onSubmitComplete: function(submitted, id){   
                                    
            if(!submitted) {
                this.$router.push({ 
                name: 'companies'})
                
            } else {
                this.$router.push({ 
                name: 'companies_update', 
                params: { 
                        id: id 
                }})
            }
        },
        async init(){
            this.loading=true
            await Promise.all([
                this.$store.dispatch('companies/getAll'),
                this.$store.dispatch('adresses/getAll'),
                this.$store.dispatch('companycategories/getAll'),
            ])
            if(typeof this.routeid != 'undefined') {   
                await this.$store.dispatch('companies/getById', this.routeid)
            }
            this.loading=false
        }
    },
    mounted() {
        this.init()
        
       
    }
    
    
}
</script>